import { http } from "services/http";

import type {
  InterestGeneratorDeleteRequest,
  InterestGeneratorRequest,
  InterestGeneratorSaveRequest,
  InterestGeneratorUpdateRequest,
  InterestTable,
  Plan,
  PlanAddRequest,
  PlanFieldsSettings,
  PlanFieldsSettingsRequest,
  PlanIdRequest,
  PlanListItem,
  PlansSelectRequest,
  PlanUpdateRequest,
} from "models/plans.model";
import type { SelectOption } from "models/common.model";

export const plansApi = {
  savePlan: (data: PlanAddRequest) => http.quiet().post("/api/plans/add", { ...data }),
  updatePlan: (data: PlanUpdateRequest) => http.quiet().post("/api/plans/update", { ...data }),
  getPlan: (data: PlanIdRequest) => http.quiet().post<Plan>("/api/plans/get", { ...data }),
  getPlansList: () => http.quiet().get<PlanListItem[]>("/api/plans"),
  deletePlan: (data: PlanIdRequest) => http.quiet().post("/api/plans/delete", { ...data }),
  getListForSelect: (data: PlansSelectRequest) =>
    http.quiet().post<SelectOption[]>("/api/get-plans", { ...data }),
  interestGenerator: (data: InterestGeneratorRequest) =>
    http.quiet().post<InterestTable>("/api/plans/interest-generator", { ...data }),
  interestGeneratorSave: (data: InterestGeneratorSaveRequest) =>
    http.quiet().post<InterestTable>("/api/plans/interest-generator/store", { ...data }),
  interestGeneratorDelete: (data: InterestGeneratorDeleteRequest) =>
    http.quiet().post("/api/plans/interest-generator/delete", { ...data }),
  interestGeneratorUpadte: (data: InterestGeneratorUpdateRequest) =>
    http.quiet().post("/api/plans/interest-generator/update", { ...data }),
  fieldsSettingsRequest: (data: PlanFieldsSettingsRequest) =>
    http.quiet().post<PlanFieldsSettings>("/api/plans/fields-settings", { ...data }),
};
